import { Component, OnInit, effect} from '@angular/core';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import {LocalizationService} from '../../../../../../src/core/utilitites/localization.service';
@Component({
    selector: 'app-remote-login',
    templateUrl: './remote-login.component.html',
    styleUrls: ['./remote-login.component.scss'],
    standalone: false
})
export class RemoteLoginComponent implements OnInit {
    constructor(private route: Router, private localizationService: LocalizationService) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.translatedLabels = this.localizationService.reparseLocalizedStrings(this.translatedLabels);
        });
    }
    public edited = true;
    public labels: string[] = ['data.Code.Transaction_Cd.Code_Desc.LGOT'];
    public translatedLabels: Record<string, string>;

    ngOnInit(): void {
        if (location.hash != '') {
            if (
                location.hash?.split('&')[1].indexOf('error_description') != -1
            ) {
                this.edited = false;
                this.route.navigateByUrl('/my-account');
            }
        }
        this.translatedLabels = this.localizationService.loadLocalizedStrings(this.labels);
    }

    onCancel() {
        this.secMFALogin();
        this.route.navigateByUrl('/my-account');
        return;
    }
    secMFALogin() {
        let decoded: any;
        if (location.hash != '') {
            if (location.hash?.split('&')[1].indexOf('access_token') != -1) {
                decoded = jwt_decode(
                    location.hash?.split('&')[1]?.split('access_token=')[1]
                );
            }
        }
        if (decoded != undefined) {
            sessionStorage.removeItem('access_token');
            sessionStorage.setItem(
                'access_token',
                location.hash?.split('&')[1]?.split('access_token=')[1]
            );
        }
        return decoded;
    }
}
